<script lang="ts">
  interface Achievement {
    icon: string;
    name: string;
    desc: string;
    earned: boolean;
  }

  let { achievements }: { achievements: Achievement[] } = $props();

  const earnedCount = $derived(achievements.filter((a) => a.earned).length);
</script>

{#if achievements.length > 0}
  <div class="achievements-section">
    <h2>Achievements <span class="earned-count">{earnedCount}/{achievements.length}</span></h2>
    <div class="achievements-grid">
      {#each achievements as ach}
        <div class="achievement" class:achievement--locked={!ach.earned} title={ach.desc}>
          <span class="achievement-icon">{ach.icon}</span>
          <span class="achievement-name">{ach.name}</span>
        </div>
      {/each}
    </div>
  </div>
{/if}

<style>
  .achievements-section {
    margin-top: 2rem;
  }
  .achievements-section h2 {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  .earned-count {
    font-size: 0.75rem;
    font-weight: 400;
    color: var(--text-muted);
  }
  .achievements-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.5rem;
  }
  .achievement {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 0.75rem 0.5rem;
    text-align: center;
    cursor: default;
    transition: border-color 0.2s;
  }
  .achievement:hover {
    border-color: var(--pink);
  }
  .achievement-icon {
    font-size: 1.5rem;
    line-height: 1;
  }
  .achievement-name {
    font-size: 0.7rem;
    font-weight: 600;
    color: var(--text-primary);
  }
  .achievement--locked {
    opacity: 0.3;
    filter: grayscale(1);
  }
  .achievement--locked:hover {
    border-color: var(--border);
  }
</style>
